import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    lang: {
        locales: {
            'pt-BR': {
                dataTable: {
                    itemsPerPageText: 'Itens por página',
                    ariaLabel: {
                        sortDescending: 'Ordenado decrescente.',
                        sortAscending: 'Ordenado crescente.',
                        sortNone: 'Não ordenado.',
                        activateNone: 'Ative para remover a ordenação.',
                        activateDescending: 'Ative para ordenar decrescente.',
                        activateAscending: 'Ative para ordenar crescente.'
                    },
                    noDataText: 'Nenhum dado disponível'
                }
            }
        },
        current: 'pt-BR'
    },

    icons: {
        iconfont: 'mdi'
    },
    theme: {
        options: {
            customProperties: true
        },
        themes: {
            light: {
                primary: '#012a4a',
                secondary: '#c98450',
                gray: '#EAEAEA',
                warning: '#FFCC00',
                lightGray: '#EFEFEF',
                black: '#000000',
                mediumGray: '#959595',
                darkGray: '#9E9E9E',
                important: '#FB3A04',
                lightImportant: '#FEF2F2',
                white: '#FFFFFF',
                accent: '#AAD3C7',
                error: '#FF5252'
            }
        }
    }
});
